import { Component, inject, input, ChangeDetectionStrategy } from "@angular/core";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { DateTime } from "luxon";
import { DialogService, DynamicDialogRef } from "@openng/optimus-ui/dynamicdialog";
import { SendEmailFormComponent } from "../send-email-form/send-email-form.component";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Protocol } from "../../../models/ui/protocol";

@Component({
  selector: "app-document-list-item",
  standalone: true,
  imports: [SvgIconComponent, TranslateModule],
  templateUrl: "./document-list-item.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./document-list-item.component.scss",
})
export class DocumentListItemComponent {
  public config = input<Protocol>();
  private dialogService = inject(DialogService);
  private ref: DynamicDialogRef | null = null;
  private translate = inject(TranslateService);

  public convertToTimeString(timestamp: number | undefined) {
    if (timestamp) {
      const date = DateTime.fromMillis(timestamp);
      return date.toFormat("dd.MM.yyyy HH:mm");
    } else {
      return "";
    }
  }
  public onOpenClick() {
    window.open(this.config()?.url, "_blank");
  }
  public onEmailClick(docId: string) {
    this.ref = this.dialogService.open<SendEmailFormComponent>(SendEmailFormComponent, {
      header: this.translate.instant("protocols.send_protocol_email.header"),
      modal: true,
      width: "50vw",
      contentStyle: { overflow: "auto" },
      breakpoints: {
        "960px": "75vw",
        "640px": "90vw",
      },
      data: { docId },
      closable: true,
    });

    this.ref?.onClose.subscribe(() => {
      // TODO: create message if successfull
    });
  }
}
